const lang = {
    cancel: 'Cancel',
    close: 'Close',
    ok: 'OK',
    country: {
        china: 'China',
        hongKong: 'HongKong',
        macau: 'Macau',
        taiwan: 'Taiwan',
        singapore: 'Singapore',
        malaysia: 'Malaysia',
        indonesia: 'Indonesia',
        thailand: 'Thailand',
        philippines: 'Philippines',
        vietnam: 'Vietnam',
        myanmar: 'Myanmar'
    },
    friendlyTime: {
        just: 'Just',
        yesterday: 'Yesterday',
        oneMinuteAgo: '1 minute ago',
        minutesAgo: 'minutes ago',
        oneHourAgo: '1 hour ago',
        hoursAgo: 'hours ago',
        daysAgo: 'days ago',
        weeksAgo: 'weeks ago',
    },
    loading: 'Loading…',
    page: {
        loadMore: 'Load More',
        loading: 'Loading',
        noMore: 'There is no more Data'
    },
    empty: {
        noData: 'No data yet',
        noAttention: 'No attention yet',
        noNetwork: 'No network yet',
        theServerIsWrong: 'The server is wrong',
        underConstructionAndWorkingHardToMaintain: 'Under construction, working hard to maintain',
        pleaseWaitPatientlyForCertificationAndReview: 'Patience, review, please be patient',
        searchNoResults: 'Search no results',
    },
    selectMember: {
        all: 'All',
        title: 'Select Member',
        titleRange: 'Select Range',
        selected:'Selected',
        search: 'Search',
        clear:'Clear',
        cancel:'Cancel',
        ok:'OK',
        dept:'Department',
        deptMember:'Department member',
        group:'Group',
        groupMember:'Group member',
        team: 'Team',
        teamMember: 'Team member',
        member:'Member',
        includingSubordinate: 'Including subordinate',
        cancelSubordinate: 'Cancel subordinate',
        publicTeam: 'Public team',
        privateTeam: 'Personal team',
        maximum: 'The maximum limit has been exceeded'
    }
}

export default lang



// WEBPACK FOOTER //
// ./src/locale/lang/en-US.js